import React from 'react';
import { MessageSquare, Shield, AlertTriangle, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

const SMSAnalyzerTab = ({ smsInput, setSmsInput, analyzeSMS, smsScanResult, loading }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl border shadow-sm p-6">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <MessageSquare className="h-5 w-5 text-purple-500" />
                SMS Analyzer
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                Paste SMS content to analyze for scams, phishing, and threats
              </p>
              
              <div className="space-y-4">
                <textarea
                  value={smsContent}
                  onChange={(e) => setSmsContent(e.target.value)}
                  placeholder="Paste the SMS message here..."
                  className="w-full h-32 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 resize-none"
                />
                <Button onClick={scanSMS} className="w-full bg-orange-600 hover:bg-orange-700">
                  <Search className="h-4 w-4 mr-2" />
                  Analyze SMS
                </Button>
                
                <div className="text-xs text-gray-500">
                  <p className="font-medium mb-1">Test Messages:</p>
                  <button 
                    onClick={() => setSmsContent('URGENT: Your bank account has been suspended! Click here to verify: https://secure-bank-login.com/verify immediately to avoid account closure.')}
                    className="text-purple-600 hover:underline block"
                  >
                    Bank scam example
                  </button>
                  <button 
                    onClick={() => setSmsContent('Congratulations! You have won a prize of $10,000! Click here to claim: https://prize-winner.com/claim')}
                    className="text-purple-600 hover:underline block"
                  >
                    Prize scam example
                  </button>
                </div>
              </div>
            </div>
            
            {/* SMS Scan Result */}
            <div className="bg-white rounded-xl border shadow-sm p-6">
              <h3 className="font-semibold text-gray-900 mb-4">Analysis Result</h3>
              
              {smsScanResult ? (
                <div className="space-y-4">
                  <div className={`p-4 rounded-xl border-2 ${
                    smsScanResult.verdict === 'safe' ? 'bg-green-50 border-green-200' :
                    smsScanResult.verdict === 'malicious' ? 'bg-red-50 border-red-200' :
                    'bg-orange-50 border-orange-200'
                  }`}>
                    <div className="flex items-center justify-between mb-2">
                      <span className={`text-lg font-bold ${
                        smsScanResult.verdict === 'safe' ? 'text-green-700' :
                        smsScanResult.verdict === 'malicious' ? 'text-red-700' :
                        'text-orange-700'
                      }`}>
                        {smsScanResult.verdict.toUpperCase()}
                      </span>
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                        smsScanResult.risk_score < 30 ? 'bg-green-200 text-green-800' :
                        smsScanResult.risk_score < 60 ? 'bg-orange-200 text-orange-800' :
                        'bg-red-200 text-red-800'
                      }`}>
                        Risk: {smsScanResult.risk_score}/100
                      </span>
                    </div>
                    <p className="text-sm">{smsScanResult.recommendation}</p>
                  </div>
                  
                  {smsScanResult.extracted_urls?.length > 0 && (
                    <div>
                      <p className="font-medium text-sm mb-2">Extracted URLs:</p>
                      <div className="space-y-1">
                        {smsScanResult.extracted_urls.map((url) => (
                          <div key={url} className="p-2 bg-gray-50 rounded text-sm truncate">
                            {url}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {smsScanResult.threats?.length > 0 && (
                    <div>
                      <p className="font-medium text-sm mb-2">Issues Found:</p>
                      <div className="space-y-2">
                        {smsScanResult.threats.map((threat) => (
                          <div key={threat.name || threat.type} className="p-2 bg-red-50 rounded border-l-4 border-red-400">
                            <p className="text-sm font-medium text-red-800">{threat.type.replace('_', ' ')}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-center py-8 text-gray-500">
                  <MessageSquare className="h-12 w-12 mx-auto mb-2 text-gray-300" />
                  <p>Paste an SMS message to analyze its content</p>
                </div>
              )}
            </div>
          </div>
);

export default SMSAnalyzerTab;
